// import {demoArtistsData} from './demo-booking-data';

import { intersection, groupBy, pick, merge } from 'lodash';

import { pipe, chain } from 'ramda';
import { subYears, addMonths, addYears, format } from 'date-fns';
import { prop, map, pick as RPick, range } from 'ramda';

const artistId = 'artist_id';
const calendarDateId = 'calendar_date_id';

export const BookingArtist = {
  PRIMARY_KEY: `${artistId}&${calendarDateId}`,
  create: function ({
    artist_after = undefined,
    artist_before = undefined,
    artist_id = undefined,
    artist_id_name = undefined,
    artist_name = undefined,
    booking_location_id = undefined,
    booking_location_id_name = undefined,
    booking_location_name = undefined,
    booking_location_stage_id = undefined,
    booking_location_stage_name = undefined,
    booking_status_colour = undefined,
    booking_status_id = undefined,
    booking_status_name = undefined,
    c1 = undefined,
    c2 = undefined,
    calendar_date_artist_id = undefined,
    calendar_date_id = undefined,
    cancelled_invoices = undefined,
    city = undefined,
    company_name = undefined,
    confirmed_flag = undefined,
    contact_email1 = undefined,
    contact_id = undefined,
    contact_phone1 = undefined,
    contact_phone2 = undefined,
    contacts_contact = undefined,
    contract_flag = undefined,
    contracts_out_flag = undefined,
    contracts_sent_date = undefined,
    contracts_signed_flag = undefined,
    country = undefined,
    date_name = undefined,
    default_agent_commission = undefined,
    email1 = undefined,
    end_date = undefined,
    first_name = undefined,
    first_offer_notes = undefined,
    invoices_out_flag = undefined,
    iso2 = undefined,
    itinerary_artist_flag = undefined,
    itinerary_promoter_flag = undefined,
    last_modified = undefined,
    last_name = undefined,
    local_details_confirmed_flag = undefined,
    nick_name = undefined,
    paid_invoices = undefined,
    partially_paid_invoices = undefined,
    performance_time = undefined,
    performance_time_contract = undefined,
    performance_type = undefined,
    promoter_contact = undefined,
    promoter_email1 = undefined,
    promoter_phone1 = undefined,
    promoter_phone2 = undefined,
    riders_out_flag = undefined,
    schedule_notes = undefined,
    soundcheck = undefined,
    stage_name = undefined,
    start_date = undefined,
    total_invoices = undefined,
    travel_details = undefined,
    user_id = undefined,
    user_name = undefined,
    invoice_status_color = undefined,
    travel_status_color = undefined,
    exclusive_icon = undefined,
    exclusivity_json_data = undefined,
    exclusivity_conflicts = undefined,
    conflict_ids = undefined
  } = {}) {

    artist_id = artist_id && artist_id.toString();
    calendar_date_id = calendar_date_id && calendar_date_id.toString();

    if (!(
      artist_id && artist_id.length > 0 &&
      calendar_date_id && calendar_date_id.length > 0
    )) {
      // console.log(arguments);

      //TODO: Throw proper error so that all booking have Artist ID and Calendar Date Id.
      // For now - Error is turned cause some booking from artist->bookings does not contain artist_id
      console.error(`
        Not a valid Booking Artist Model.
        Booking must have Artist ID and Calendar Date ID.
        Not throwing error for now - fix it quickly
      `);

      return undefined;

      // throw Error(
      //   `Not a valid Booking Artist Model.
      //   Booking must have Artist ID and Calendar Date ID.`);
    }

    return {
      PRIMARY_KEY: `${artist_id}__${calendar_date_id}`,
      artist_after,
      artist_before,
      artist_id_name,
      artist_id,
      artist_name,
      booking_location_id_name,
      booking_location_id,
      booking_location_name,
      booking_location_stage_id,
      booking_location_stage_name,
      booking_status_colour,
      booking_status_id,
      booking_status_name,
      c1,
      c2,
      calendar_date_artist_id,
      calendar_date_id,
      cancelled_invoices,
      city,
      company_name,
      confirmed_flag,
      contact_email1,
      contact_id,
      contact_phone1,
      contact_phone2,
      contacts_contact,
      contract_flag,
      contracts_out_flag,
      contracts_sent_date,
      contracts_signed_flag,
      country,
      date_name,
      default_agent_commission,
      email1,
      end_date,
      first_name,
      first_offer_notes,
      invoices_out_flag,
      iso2,
      itinerary_artist_flag,
      itinerary_promoter_flag,
      last_modified,
      last_name,
      local_details_confirmed_flag,
      nick_name,
      paid_invoices,
      partially_paid_invoices,
      performance_time_contract,
      performance_time,
      performance_type,
      promoter_contact,
      promoter_email1,
      promoter_phone1,
      promoter_phone2,
      riders_out_flag,
      schedule_notes,
      soundcheck,
      stage_name,
      start_date,
      total_invoices,
      travel_details,
      user_id,
      user_name,
      invoice_status_color,
      travel_status_color,
      exclusive_icon,
      exclusivity_json_data,
      exclusivity_conflicts,
      conflict_ids,
      getStatusColor: function () {
        return getBookingStatusColor(this.booking_status_name);
      },
      getAritst: function () {
        return {
          artist_name: this.artist_name,
          artist_id: this.artist_id,
          artist_id_name: this.artist_id_name,
        }
      },
    };
  },

  // Get primary key from the Booking Artist Item
  getPrimaryKey: prop('PRIMARY_KEY'),

  // Get Primary Key list from the Booking Artist Array
  getPrimaryKeys: map(prop('PRIMARY_KEY')),

  select: function (bookingArtistList = [], properties = []) {
    return bookingArtistList.map(e => pick(e, ...properties))
  },

  getUniqueArtistsList: function (bookingArtistList = []) {
    return getUniqueArtistFromBookingArtistList(bookingArtistList);
  },
  getUniqueLocations: function (bookingArtistList = []) {
    return uniqueByProp(bookingArtistList, 'booking_location_name');
  },
  getUniqueCities: function (bookingArtistList = []) {
    return uniqueByProp(bookingArtistList, 'city');
  },
  // Takes a array and returns BookingArtist Array 
  dataToList: function (baArray = []) {
    return baArray.map(BookingArtist.create).filter(e => e);
  },
  //Alias of dataToList 
  toList: function (baArray = []) {
    return baArray.map(BookingArtist.create).filter(e => e);
  },
  toPkList: function (bookingArtistList) {
    return bookingArtistList
      .map(this.create)
      .map(ba => ba.PRIMARY_KEY);
  },
  fromPKtoList: function (bookingArtistList = [], primary_keys = []) {
    return bookingArtistList.filter(ba => primary_keys.includes(ba.PRIMARY_KEY))
  },
  update: function (bookingArtist, newBookingArtist) {

    console.log(mapChanges(bookingArtist, newBookingArtist).filter(e => e && (e.change === 'CREATED' || e.change === 'UPDATED')))

    console.log(filterUndefined(newBookingArtist));
    newBookingArtist = filterUndefined(newBookingArtist);

    return {
      ...bookingArtist,
      ...newBookingArtist
    };
  },
  updateList: function (bookingArtistList = [], newBookingArtistList = []) {
    if (!(newBookingArtistList && newBookingArtistList.length > 0)) {
      return bookingArtistList;
    }

    newBookingArtistList = this.dataToList(newBookingArtistList);
    return bookingArtistList.map(ba => {
      const newBa = newBookingArtistList.find(nb => nb.PRIMARY_KEY == ba.PRIMARY_KEY)
      if (newBa) {
        return this.update(ba, newBa);
      }
      return ba;
    });
  },
  findByPk: function (bookingArtistList = [], PRIMARY_KEY) {
    return bookingArtistList.find(e => e.PRIMARY_KEY === PRIMARY_KEY);
  },
  without: function (pkList = [], bookingArtistList = []) {
    return bookingArtistList.filter(booking => !pkList.includes(booking.PRIMARY_KEY))
  }
}

const mapChanges = (obj1, obj2) => {
  return intersection(Object.keys(obj1), Object.keys(obj2)).map(key => {
    const oldValue = obj1[key];
    const newValue = obj2[key];
    if (oldValue && !newValue) {
      return {
        key, change: 'DELETED',
        newValue,
        oldValue,
      }
    } else if (!oldValue && newValue) {
      return {
        key, change: 'CREATED',
        newValue,
        oldValue,
      }
    } else if (!oldValue && !newValue) {
      return {
        key, change: 'NOT_CHANGED',
        newValue,
        oldValue,
      }
    } else if (newValue !== oldValue) {
      return {
        key, change: 'UPDATED',
        newValue,
        oldValue,
      }
    }
  })
}


export const filterUndefined = (obj) => {
  return Object.keys(obj)
    .filter(k => obj[k])
    .reduce((accm, cur) => {
      accm[cur] = obj[cur];
      return accm;
    }, {});
};


export const getBookingStatusColor = (booking_status_name) => {
  return BookingStatusColorMap[booking_status_name] || '#FFFFFF';
}
export const EXTERNAL_CALENDAR_DATE = 'EXTERNAL_CALENDAR_DATE';

export const setBookingStatusColorMap = (map) => {
  BookingStatusColorMap = {
    ...BookingStatusColorMap,
    ...map
  };
}

export const getBookingStatuses = () => {
  return Object.keys(BookingStatusColorMap);
}

let BookingStatusColorMap = {

};

export const bookingIdMap = {
  "cancelled": "24",
  "Confirmed": "54",
  "confirmed (not public)": "3",
  "Day Off": "48",
  "privat": "73",
  "Request": "51",
  "TBC": "49"
};

export const mapBookingToIds = (keys) => {
  return keys.map(e => bookingIdMap[e]);
}




export const getArtistsFromBookingArtists = bookingArtistList => bookingArtistList.map(e => e.getAritst());
export const groupUniqueItems = key => items => groupBy(items, key);
export const mergeUniqueItems = uniqueItems => Object.keys(uniqueItems).map(k => { const e = uniqueItems[k]; return merge(...e) });

export const getUniqueArtistFromBookingArtistList = pipe(
  BookingArtist.dataToList,
  getArtistsFromBookingArtists,
  groupUniqueItems('artist_id'),
  mergeUniqueItems,
);


export const uniqueByProp = (arr, prop) => Array.from(new Set(arr.map(e => e[prop]))).filter(e => e);


// console.log(new Date())

const today = new Date();

const prY = subYears(today, 10);
// console.log(prY);

const getFirstDayOfTheYear = date => new Date(date.getFullYear(), 0, 1);
const getAllMonthsOfTheYear = date => {
  date = getFirstDayOfTheYear(date);
  return range(0, 12).map(month => addMonths(date, month))
};

const getMonthsFromYearRange = (ago, size = ago + 1) => date => {
  date = subYears(getFirstDayOfTheYear(date), ago);
  return chain(e => getAllMonthsOfTheYear(addYears(date, e)), range(0, size))
}

export const createDropdownItem = date => ({
  text: format(date, 'MMMM YYYY'),
  value: format(date, 'YYYYMM'),
  date: date
})

const getDropdownItems = dates => dates.map(createDropdownItem)

const getPrevious10YearsMonthsDropdown = pipe(
  getMonthsFromYearRange(10),
  getDropdownItems,
);

export const previous10YearsMonthsDropdown = getPrevious10YearsMonthsDropdown(new Date());

export const getBookingRangeModel = RPick([
  'artist_name',
  'start_date',
  'end_date',
  'city',
  'calendar_date_id',
]);


export const CalendarStack = {
  create: function (eventLength = 100, weekCount = 6, dayCount = 7) {
    return range(0, weekCount).map(w => {
      return range(0, dayCount).map(d => {
        return range(0, eventLength).map(e => 0);
      })
    })
  },
  nextSpot: function (day) {
    return day.findIndex(e => e === 0);
  },
  next: function (stack, weekIndex, dayIndex) {
    return this.nextSpot(stack[weekIndex][dayIndex]);
  },
  weekHeight: function (stack, weekIndex) {
    return Math.max(...stack[weekIndex].map(this.nextSpot));
  },
  populate: function (stack, weekIndex, topIndex, leftIndex, rightIndex) {
    range(leftIndex, rightIndex + 1).forEach(dayIndex => {
      stack[weekIndex][dayIndex][topIndex] = 1;
    });
    return stack;
  }
};

export const fromExternalDateToBooking = ({
  external_link_id,
  notes,
  m_artist_id,
  external_calendar_date_id,
  created,
  date,
  artist_id,
  last_modified,
  subject,
  artist_name,
}) => {

  return {
    PRIMARY_KEY: external_calendar_date_id,
    start_date: date,
    end_date: date,
    artist_name,
    booking_location_name: subject,

    isExternal: true,
    booking_status_name: EXTERNAL_CALENDAR_DATE,
    city: notes
  }
};


export const createDistancedBooking = ({
  PRIMARY_KEY,
  start_date,
  end_date,

  artist_name,
  city,
  booking_location_name,
  booking_status_name,
}) => {
  return {
    PRIMARY_KEY,
    start_date,
    end_date,

    artist_name,
    city,
    booking_location_name,
    booking_status_name,
  };
};



export const createFlatBooking = (booking, artist_id) => {
  console.log('MDSIRR', booking);
  const artist = booking?.artists?.find((a) => a.artist_id == artist_id) || {};
  const cdate = booking?.cdate || {};
  const location = booking?.location || {};
  const promoter = booking?.promoter || {};

  const start_date = cdate?.start_date || "";
  const booking_location_name = location?.booking_location_name || "";
  const city = location?.city || "";
  const country = location?.country || "";
  const first_offer_notes = artist?.first_offer_notes || "";
  const email_to = artist?.email1 || "";
  const artist_name = artist?.artist_name || "";
  const artist_stage = artist?.stage_name || "";
  const performance_type = artist?.performance_type || "";
  const event_name = cdate.date_name || "";
  const notes_ical = cdate?.notes;
  const line_up = cdate?.lineup;
  const calendar_date_id = cdate?.calendar_date_id;
  const venue_name = location?.booking_location_name;
  const venue_address = location?.address1;
  const venue_city = location?.city;
  const venue_postalcode = location?.postalcode || "";
  const venue_country = location?.country || "";
  const venue_phone = location?.phone1 || "";
  const venue_email = location?.email || "";
  const venue_url = location?.url1 || "";
  const venue_capacity = location?.venue_capacity || "";

  const promoter_company_name = promoter?.company_name || "";
  const promoter_representative = promoter?.company_legalname || "";

  const promoter_first_name = promoter?.first_name || "";
  const promoter_last_name = promoter?.last_name || "";

  const promoter_address = promoter?.address1 || "";
  const promoter_city = promoter?.city || "";
  const promoter_postalcode = promoter?.postalcode || "";
  const promoter_state = promoter?.region || "";
  const promoter_country = promoter?.country || "";
  const promoter_phone = promoter?.phone1 || "";
  const promoter_mobile = promoter?.phone2 || "";
  const promoter_email = promoter?.email1 || "";
  const promoter_vat_id = promoter?.vat_no || "";
  const promoter_url = promoter?.url || "";
  const promoter_language = promoter?.language || "";

  return {
    start_date,
    booking_location_name,
    city,
    country,
    first_offer_notes,
    email_to,
    artist: artist_name,
    artist_stage,
    performance_type,
    event_name,
    notes_ical,
    calendar_date_id,
    line_up,

    venue_name,
    venue_address,
    venue_city,
    venue_postalcode,
    venue_country,
    venue_phone,
    venue_email,
    venue_url,
    venue_capacity,

    promoter_company_name,
    promoter_representative,
    promoter_first_name,
    promoter_last_name,
    promoter_address,
    promoter_city,
    promoter_postalcode,
    promoter_state,
    promoter_country,
    promoter_phone,
    promoter_mobile,
    promoter_email,
    promoter_vat_id,
    promoter_url,
    promoter_language,
  };
};